<template>
  <el-checkbox-group v-model="mySelectedValue" :disabled="disabled">
    <el-checkbox v-for="item in Option" :key="item.value" :label="item.value" :value="item.value">{{ item.name }}</el-checkbox>
  </el-checkbox-group>
</template>

<script>
// 字典数据表
import { getDictOptions } from '@/api/sys/dictionary'
// 复选框字典组件
export default {
  name: 'DictionaryCheckBox',
  // 接受父组件传递的消息
  props: {
    /**
     * 字典类型编码(eg: 性别-gender)
     */
    typeCode: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [String,Array],
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      mySelectedValue: [],
      Option: []
    }
  },
  watch: {
    // 监听父组件传入的数据，更新到本地
    modelValue(newVal) {
      if (newVal != '' && undefined != newVal) {
        this.mySelectedValue = newVal;
      } else {
        this.mySelectedValue = ''
      }
    },
    // myCompanyId 修改后通知 父级模块
    mySelectedValue(newVal) {
      this.$emit('change', newVal)
    }
  },
  mounted() {
    if (this.modelValue != '' && undefined != this.modelValue) {
        this.mySelectedValue = this.modelValue;
    }
    this._getDictOptionsList()
  },
  methods: {
    _getDictOptionsList() {
      getDictOptions(this.typeCode).then(response => {
        this.Option = []
        this.Option.push(...response.data)
      })
    }
  }
}
</script>
